import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicAssetUrl } from "../../lib/adminApi";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

export default function AlumniPortal() {
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    const params = new URLSearchParams();
    if (query) params.set("q", query);
    try {
      const res = await fetch(`${API_BASE}/api/alumni${params.toString() ? `?${params}` : ""}`);
      const data = await res.json();
      setRows(Array.isArray(data) ? data : []);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <main className="min-h-screen bg-slate-50">
      <section className="bg-gradient-to-br from-emerald-950 via-emerald-800 to-yellow-600 px-4 py-20 text-white">
        <div className="mx-auto max-w-6xl">
          <p className="text-sm font-black uppercase tracking-[0.35em] text-yellow-200">FPB Alumni Network</p>
          <h1 className="mt-4 max-w-4xl text-4xl font-black md:text-6xl">Celebrating graduates making impact across Nigeria and beyond.</h1>
          <p className="mt-5 max-w-3xl text-lg text-emerald-50">Explore alumni stories, achievements, mentorship opportunities and success journeys from Federal Polytechnic Bida graduates.</p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 py-10">
        <div className="mb-8 rounded-3xl bg-white p-5 shadow-sm ring-1 ring-slate-200">
          <div className="grid gap-3 md:grid-cols-[1fr_140px]">
            <input value={query} onChange={(e) => setQuery(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} placeholder="Search alumni by name, programme, role or achievement..." className="rounded-xl border border-slate-300 px-4 py-3" />
            <button onClick={load} className="rounded-xl bg-emerald-700 px-4 py-3 font-bold text-white">Search</button>
          </div>
        </div>

        {loading ? <p>Loading alumni stories...</p> : rows.length === 0 ? (
          <div className="rounded-3xl bg-white p-10 text-center text-slate-500 shadow-sm">No alumni stories found.</div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {rows.map((item) => (
              <article key={item.id} className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-slate-200 transition hover:-translate-y-1 hover:shadow-lg">
                <div className="h-56 bg-slate-100">
                  {item.photo_url ? <img src={publicAssetUrl(item.photo_url)} alt={item.full_name} className="h-full w-full object-cover" /> : <div className="flex h-full items-center justify-center text-5xl font-black text-emerald-700">{item.full_name?.charAt(0)}</div>}
                </div>
                <div className="p-6">
                  {item.is_featured ? <span className="rounded-full bg-yellow-100 px-3 py-1 text-xs font-black text-yellow-800">Featured Alumni</span> : null}
                  <h2 className="mt-3 text-xl font-black text-slate-950">{item.full_name}</h2>
                  <p className="mt-1 text-sm font-semibold text-emerald-700">{item.current_position || item.programme}</p>
                  <p className="mt-2 text-sm text-slate-600">{item.organization || item.location || `Class of ${item.graduation_year || "FPB"}`}</p>
                  <p className="mt-4 line-clamp-3 text-sm leading-6 text-slate-600">{item.achievement || item.story}</p>
                  <Link to={`/alumni/${item.slug}`} className="mt-5 inline-block font-bold text-emerald-700">Read story →</Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
